import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage: 'Hello, I would like to report an accident\n',
    },
    content: {
      exclude: {
        items: [
          'Any damage caused intentionally, by wear and tear, or due to a construction defect;',
          'Keys and damage to the interior of the vehicle;',
          'Trips paid with a card other than the one issued by Shine.',
        ],
        title: 'All vehicles rented from an individual.',
      },
      include: {
        items: [
          'One claim per year per user up to a limit of €5,000;',
          'Reimbursement of the deductible in case of damage, theft and attempted theft (personal effects and items), fire, or vandalism.',
        ],
        title: 'This guarantee includes',
      },
    },
    similarOffersTitle: 'Related insurance offers',
    title: 'Rental Vehicle',
  },
  fr: {
    claimButton: {
      intercomMessage: 'Bonjour, je souhaiterais déclarer un accident\n',
    },
    content: {
      exclude: {
        items: [
          'Tous dommages causés volontairement, par l’usure ou suite à un vice de construction ;',
          'Les clés et les dommages fait à l’habitacle (l’interieur du véhicule) ;',
          'Les voyages réglé avec une carte autre que celle émise par Shine.',
        ],
        title: 'Tous véhicules loués à un particulier.',
      },
      include: {
        items: [
          'Un sinistre par an et par utilisateur dans la limite de 5 000 € ;',
          'Rachat de la franchise en cas de dommages, de vols et tentative de vol (effets et objets personnels), d’incendie ou de vandalisme.',
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées',
    title: 'Véhicule de location',
  },
} as const);

export default locales;
